export const formatPersonName = (
	firstName?: string | null,
	lastName?: string | null,
) => [firstName, lastName].filter(Boolean).join(' ').trim()
